import { useEffect, useState } from "react";
import { CmsMe, fetchMe } from "./me";

export type MeState =
  | { status: "loading" }
  | { status: "error" }
  | { status: "ready"; me: CmsMe };

/**
 * Хук текущего пользователя. status="error" означает, что /cms/me недоступен
 * (например, бэк ещё без RBAC) — вызывающие стороны ведут себя fail-open,
 * чтобы не окирпичить CMS при раскатке.
 */
export const useMe = (): MeState => {
  const [state, setState] = useState<MeState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    fetchMe()
      .then((me) => {
        if (!cancelled) setState({ status: "ready", me });
      })
      .catch(() => {
        if (!cancelled) setState({ status: "error" });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
};
